import { boundStroke } from "../tools";

import { DefaultOuterBorderBoundsContribution } from "./common-contribution";

export class DefaultSymbolOuterBorderBoundsContribution extends DefaultOuterBorderBoundsContribution {
    updateBounds(attribute, symbolTheme, aabbBounds, graphic) {
        const {outerBorder: outerBorder, shadowBlur: shadowBlur = symbolTheme.shadowBlur, strokeBoundsBuffer: strokeBoundsBuffer = symbolTheme.strokeBoundsBuffer} = attribute;
        if (outerBorder) {
            const defaultOuterBorder = symbolTheme.outerBorder, {distance: distance = defaultOuterBorder.distance, lineWidth: lineWidth = defaultOuterBorder.lineWidth} = outerBorder;
            boundStroke(aabbBounds, distance + (shadowBlur + lineWidth) / 2, !0, strokeBoundsBuffer);
        }
        return aabbBounds;
    }
}
//# sourceMappingURL=symbol-contribution.js.map
